const _ = require('lodash');

const {
  filterSetToQueryFactory
} = require('./filterSetToQuery');

const queryToFilterSetFactory = require('./queryToFilterSet');

const {
  dictionaryToGeoIds,
  geoIdsToDictionary
} = require('./geoids');

const targetMap = {
  businessOfferFlags: 'businessOfferFlags',
  businessTags: 'businessTags',
  businessOfferTags: 'businessOfferTags',
  businessLocationTags: 'businessLocationTags',
  businessOfferLocationTags: 'businessOfferLocationTags',
  businessOfferLiveSince: 'businessOfferLiveSince',
  businessOfferExpiresIn: 'businessOfferExpiresIn',
  businessId: 'businessId',
  businessOfferIds: 'businessOfferIds',
  businessCategoryIds: 'businessCategoryIds',
  businessPolicyPlanId: 'businessPolicyPlanId'
};
const operationMap = {
  containsAnyOf: 'containsAnyOf',
  containsAllOf: 'containsAllOf',
  notContainsAnyOf: 'notContainsAnyOf',
  notContainsAllOf: 'notContainsAllOf',
  moreThan: 'moreThan',
  lessThan: 'lessThan',
  isAnyOf: 'isAnyOf',
  notIsAnyOf: 'notIsAnyOf'
};

const getFilterTarget = target => {
  const result = _.findKey(targetMap, it => it === target);

  if (!result) throw new Error(`Unknown target type ${target}`);
  return result;
};

const getFilterOperation = operation => {
  const result = _.findKey(operationMap, it => it === operation);

  if (!result) throw new Error(`Unknown operation ${operation}`);
  return result;
};

const getResourceConverter = target => {
  switch (target) {
    case 'businessOfferFlags':
    case 'businessTags':
    case 'businessOfferTags':
    case 'businessLocationTags':
    case 'businessOfferLocationTags':
    case 'businessOfferLiveSince':
    case 'businessOfferExpiresIn':
      return _.identity;

    case 'businessId':
    case 'businessOfferIds':
      return dictionaryToGeoIds;

    default:
      return arg => {
        if (_.isArray(arg)) return arg.map(it => ({
          id: it
        }));
        if (_.isObject(arg)) return _.mapValues(arg, it => ({
          id: it
        }));
        return {
          id: arg
        };
      };
  }
};

const getFilterArgs = (args, target, resources) => {
  const value = _.get(resources, args);

  return getResourceConverter(target)(value);
};
/* eslint-disable-next-line arrow-body-style */


const queryToFilterSet = query => {
  return queryToFilterSetFactory({
    getTarget: getFilterTarget,
    getOperation: getFilterOperation,
    getResource: getFilterArgs
  })(query);
};

const getExpressionTarget = ({
  target
}) => {
  const result = targetMap[target];
  if (!result) throw new Error(`Unknown target type "${target}"`);
  return result;
};

const getExpressionOperation = ({
  operation
}) => {
  const result = operationMap[operation];
  if (!result) throw new Error(`Unknown operation "${operation}"`);
  return result;
};

const storeResource = ({
  target,
  args
}, resources) => {
  switch (target) {
    case 'businessOfferFlags':
      {
        const name = `$offer${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          flags: args,
          __type: 'offer'
        };
        return `${name}.flags`;
      }

    case 'businessTags':
    case 'businessOfferTags':
    case 'businessLocationTags':
    case 'businessOfferLocationTags':
      {
        const name = `$tag${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          names: args,
          __type: 'tag'
        };
        return `${name}.names`;
      }

    case 'businessOfferLiveSince':
    case 'businessOfferExpiresIn':
      {
        const name = `$duration${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          minutes: args,
          __type: 'duration'
        };
        return `${name}.minutes`;
      }

    case 'businessId':
      {
        const name = `$business${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          geoIds: geoIdsToDictionary(args),
          __type: 'business'
        };
        return `${name}.geoIds`;
      }

    case 'businessOfferIds':
      {
        const name = `$offer${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          geoIds: geoIdsToDictionary(args),
          __type: 'offer'
        };
        return `${name}.geoIds`;
      }

    case 'businessCategoryIds':
      {
        const name = `$business${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          categoryIds: args.map(c => c.id),
          __type: 'business'
        };
        return `${name}.categoryIds`;
      }

    case 'businessPolicyPlanId':
      {
        const name = `$policy${Object.keys(resources).length + 1}`;
        /* eslint-disable-next-line no-param-reassign */

        resources[name] = {
          planIds: args.map(p => p.id),
          __type: 'policy'
        };
        return `${name}.planIds`;
      }

    default:
      throw new Error(`Unknown target type "${target}" for resource`);
  }
};
/* eslint-disable-next-line arrow-body-style */


const filterSetToQuery = filterSet => {
  return filterSetToQueryFactory({
    getTarget: getExpressionTarget,
    getOperation: getExpressionOperation,
    storeResource
  })(filterSet);
};

module.exports = {
  filterSetToQuery,
  queryToFilterSet
};